const packagesTypes = [
  { id: 1, label: 'child' },
  { id: 2, label: 'adult' },
  { id: 3, label: 'baby' },
];

export default packagesTypes;
